import {OrderService} from '@domain/model/Order';
import {Modality, Subscription} from '@domain/model/Account/Subscription/Subscription';
import {useOverallInfo} from '@components/_context';

import {getCurrentOrders} from '@views/Account/_hooks';

import {getOrderPendingOfReturn} from '../helpers';
import {isPreOrderState, selectActiveOrder} from './classifyMyAreaState';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const toSubscription = (subscription: any): Subscription | undefined =>
  subscription
    ? {id: subscription.id, modality: subscription.modality as unknown as Modality, lkDay: subscription.lkDay}
    : undefined;

export interface MyAreaOrder {
  readonly currentOrder?: OrderService;
  readonly orderComment?: string;
  readonly orderId?: string;
  readonly subscription?: Subscription;
  readonly orderPendingReturn?: OrderService;
}

const useMyAreaOrder = (): MyAreaOrder => {
  const {orders = [], subscription, checkout} = useOverallInfo();

  const activeOrder = selectActiveOrder(orders, checkout);
  const activeOrderService = activeOrder?.services[0];

  return {
    currentOrder: getCurrentOrders(orders, checkout).inProgress,
    orderComment: activeOrderService?.comment,
    orderId: activeOrderService?.id,
    subscription: toSubscription(subscription),
    orderPendingReturn: isPreOrderState({orders, subscription}) ? undefined : getOrderPendingOfReturn(orders),
  };
};

export {useMyAreaOrder};
